import { CountryCodes } from 'app/shared/enums/country-code.enum';
import { FrequencyEnum } from 'app/teachers/subscription/enums/frequency.enum';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderModel } from 'app/teachers/subscription/models/order.model';
import { PlanModel } from 'app/teachers/subscription/models/plan.model';
import { RegionInfo } from 'app/shared/models/region-code.model';
import { UrlService } from 'app/core/http/url.service';

@Injectable({
  providedIn: 'root'
  })
export class TeacherSubscriptionService {

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlService
  ) { }

  public isSubscriptionAvailable(region: RegionInfo): boolean {
    return region.CountryCode === CountryCodes.Canada || region.CountryCode === CountryCodes.USA;
  }

  public changeFrequency(order: OrderModel, frequency: FrequencyEnum, plans: PlanModel[]): OrderModel {
    const newOrder = order;
    newOrder.Plan = plans.find(plan => plan.Frequency === frequency);

    return this.updatePrice(newOrder);
  }

  public changeQuantity(order: OrderModel, increment: number): OrderModel {
    const newOrder = order;

    if (newOrder.Quantity + increment > 0) {
      newOrder.Quantity += increment;
    }

    return this.updatePrice(newOrder);
  }

  public updatePrice(order: OrderModel): OrderModel {
    const newOrder = order;
    newOrder.Subtotal = newOrder.Quantity * (newOrder.Plan?.Price ?? 0) * 0.01;
    newOrder.SubtotalPerMonth = newOrder.Quantity * (newOrder.Plan?.PricePerMonth ?? 0) * 0.01;

    newOrder.TaxAmount = newOrder.Subtotal * (newOrder.Region?.TaxRate ?? 0);
    newOrder.Total = newOrder.Subtotal + newOrder.TaxAmount;

    return newOrder;
  }

  public deleteTeacherPremiumSubscription(): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'Payments', 'Subscribe');

    return this.httpClient.delete<void>(url);
  }
}
